export enum ExportType {
  EXPORT_ANALYSIS = "export_analysis",
  EXPORT_MATERIALS_DEMANDS = "export_materials_demands",
  EXPORT_PO_COMPONENTS = "export_po_components",
  EXPORT_STOCK = "export_stock",
}

export enum ExportStatus {
  WAITING = "WAITING",
  STARTED = "STARTED",
  FINISHED = "FINISHED",
  ERROR = "ERROR",
}

export const EXPORT_STATUS_NUMBERS = {
  WAITING: 1,
  STARTED: 2,
  FINISHED: 3,
  ERROR: 4,
} as const;

export interface ExportInfo {
  type: ExportType;
  id: string; // analysis.id or user.id
  status: ExportStatus;
  file_url?: string;
  started_at?: string;
  ended_at?: string;
  error?: string;
  task_id?: string; // Celery task ID
  user_id?: number; // For materials demands exports
  analysis_id?: number; // For analysis exports
  group_name?: string; // WebSocket group name
  hasFilters?: boolean; // For PO Components exports with filters
}

export interface ExportContextType {
  exportsInProgress: Record<string, ExportInfo>; // key: `${type}_${id}`
  lastUpdated: number;
  updateExport: (info: ExportInfo) => void;
  removeExportAfterDelay: (type: ExportType, id: string) => void;
  getExport: (type: ExportType, id: string) => ExportInfo | undefined;
  isExporting: (type: ExportType, id: string) => boolean;
}

export interface ExportProviderProps {
  children: React.ReactNode;
  onError?: (error: ExportError) => void;
}

export interface ExportError {
  type: ExportType;
  id: string;
  message: string;
  originalError?: unknown;
}

export interface ExportSocketOptions {
  onMessage?: (data: ExportInfo) => void;
  onError?: (error: ExportError) => void;
  enabled?: boolean;
  maxRetries?: number;
  retryDelay?: number;
  shouldDownloadAutomatically?: boolean;
}

// Constantes para persistência
export const CACHE_KEYS = {
  EXPORTS_IN_PROGRESS: 'exportsInProgress',
  LAST_UPDATED: 'lastUpdated',
} as const;

export const ACTIVE_EXPORT_STATUSES = [ExportStatus.WAITING, ExportStatus.STARTED];

export const EXPORT_REMOVAL_DELAY = 1000;
